import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { IQuotationNotificationSettings } from "../interfaces/quotation-notification-settings.interface";
import { QuotationNotificationSettingsApiService } from "../services/quotation-notification-settings.service";

export const quotationNotificationSettingsResolver: ResolveFn<IQuotationNotificationSettings> = (route, _) => {
  const quotationNotificationSettingsApiService = inject(QuotationNotificationSettingsApiService);
  return quotationNotificationSettingsApiService.getQuotationNotificationSettings();
};
